import { memo as _$memo } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { A } from "@solidjs/router";
import { Show } from "solid-js";
import { SaveFlightPrompt } from "./SaveFlightPrompt.tsx";

/**
 * The Mission Recorder's whole presence inside `/fly`: the save prompt while it
 * is up, and afterwards a link into the tape it produced.
 *
 * One component rather than two `Show` blocks in the route because they are two
 * halves of one moment — the prompt is only ever replaced by the link, and the
 * link only ever appears because the prompt succeeded.
 */
export function FlightRecorderOverlay(props) {
  return [_$createComponent(Show, {
    get when() {
      return props.recording.prompting();
    },
    get children() {
      return _$createComponent(SaveFlightPrompt, {
        get suggested() {
          return props.recording.suggestedName();
        },
        get duration() {
          return props.recording.duration();
        },
        get error() {
          return props.recording.error();
        },
        get onSave() {
          return props.recording.save;
        },
        get onCancel() {
          return props.recording.closePrompt;
        }
      });
    }
  }), _$createComponent(Show, {
    get when() {
      return props.recording.savedAs();
    },
    children: name => _$createComponent(A, {
      "class": "flight__saved-tape",
      get href() {
        return `/vcr?tape=${encodeURIComponent(name())}`;
      },
      get children() {
        return ["SAVED AS ", _$memo(() => name()), " — OPEN IN THE MISSION RECORDER"];
      }
    })
  })];
}